const resolverCidadeSlug = (cidadeProp, pathname) => {
  if (typeof cidadeProp === 'string' && cidadeProp.trim() !== '') {
    return cidadeProp;
  }
  if (cidadeProp && cidadeProp.slug) {
    return cidadeProp.slug;
  }

  const currentPath =
    pathname || (typeof window !== 'undefined' ? window.location.pathname : '');

  if (currentPath.includes('belo-horizonte')) {
    return 'belo-horizonte';
  }
  if (currentPath.includes('sao-paulo')) {
    return 'sao-paulo';
  }

  if (typeof window !== 'undefined' && window.sessionStorage) {
    const saved = window.sessionStorage.getItem('cidadeAtivaPage') || '';
    if (saved.includes('belo-horizonte')) {
      return 'belo-horizonte';
    }
    if (saved.includes('sao-paulo')) {
      return 'sao-paulo';
    }
  }

  return 'sao-paulo';
};

export default resolverCidadeSlug;
